
export function useRecentBookings() {
  const bookings = []  
  const isLoading = false
  return { bookings, isLoading };
}
